import axios from "axios";
import * as Safe from "safe-portals";

type Permission = string;
type AcceptedHTTPMethods = "GET" | "POST";
export interface Route<Args, Resp> {
  url: string;
  permissions: "public" | Permission[];
  argumentType: Safe.Type<Args>;
  responseType: Safe.Type<Resp>;
  call: (args: Args) => Promise<Resp>;
  method: AcceptedHTTPMethods;
}
export function makeRoute<Args, Resp>(
  url: string,
  permissions: "public" | Permission[],
  argumentType: Safe.Type<Args>,
  responseType: Safe.Type<Resp>,
  method: AcceptedHTTPMethods = "POST"
): Route<Args, Resp> {
  return {
    url,
    method,
    permissions,
    argumentType,
    responseType,
    call: async (args: Args): Promise<Resp> => {
      if (method === "GET") {
        const resp = await axios.get(url, { params: { args: argumentType.write(args) } });
        return responseType.read(resp.data.result);
      } else {
        const resp = await axios.post(url, { args: argumentType.write(args) }, { headers: { "x-csrf": "1" } });
        return responseType.read(resp.data.result);
      }
    },
  };
}
